import React from 'react';

import { cn } from 'src/component/ds/utils';
import { SidebarMenuSubButton, SidebarMenuSubItem } from 'src/component/ds/ui/sidebar';
import { navCountPillClassName, navLeafClassName } from './navRow';

interface DeviceNavLeafProps {
  tag: string;
  childCount?: number;
  active: boolean;
  onSelect: () => void;
}

/* A controller (or standalone circuit) nested under a panel, group or connection. */
export default function DeviceNavLeaf ({ tag, childCount, active, onSelect }: DeviceNavLeafProps) {
  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton asChild isActive={active} className={navLeafClassName}>
        <button type='button' onClick={onSelect} title={tag} aria-current={active ? 'true' : undefined}>
          <span className='ds-min-w-0 ds-flex-1 ds-truncate'>{tag}</span>
          {childCount !== undefined && (
            <span
              className={cn(
                navCountPillClassName,
                'ds-flex ds-min-w-5 ds-shrink-0 ds-items-center ds-justify-center',
                active && 'ds-bg-sidebar-accent-tint'
              )}
            >
              {childCount}
            </span>
          )}
        </button>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
